import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  Tick,
} from "chart.js";
import { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { CompensationByAge } from "../../../openApi/api";
import { jpNumFormatter } from "../../../utils/formatter";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface Props {
  chartData: CompensationByAge[];
}

type ChartData = {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string;
  }[];
};

export const CompensationChart = ({ chartData }: Props) => {
  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "",
      },
    },
    scales: {
      y: {
        ticks: {
          callback: (
            tickValue: string | number,
            index: number,
            ticks: Tick[]
          ) => {
            return jpNumFormatter(
              typeof tickValue === "number"
                ? (tickValue as number)
                : parseInt(tickValue as string)
            );
          },
        },
      },
    },
  };

  const barData = useMemo(() => {
    const data: ChartData = {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: "rgb(0,102,255)",
        },
      ],
    };

    chartData.forEach((ageInsurance, index) => {
      // data.labels.push(`${ageInsurance.age!}${index === 0 ? "歳" : ""}`);
      // data.datasets[0].data.push(parseInt(ageInsurance.value!));
      const value = parseInt(ageInsurance.value!);
      data.labels.push(`${ageInsurance.age!}${index === 0 ? "歳" : ""}`);
      data.datasets[0].data.push(value === 0 ? 2000000 : value);
    });
    return data;
  }, [chartData]);

  return <Bar options={options} data={barData} />;
};
